// extracted by mini-css-extract-plugin
export default {"search":"Search_search__aGdxg","groupNameInvalid":"Search_groupNameInvalid__lwX8B"};